import React, { useEffect, useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { useAuth } from "components/AuthProvider";
import { useMutation } from "react-query";
import { createCustomerSession } from "api/v2/customerSessions";
import Spinner from "components/spinner";

const Wrap = styled.div`
  ${tw`w-full mx-auto px-[15px]`}
  max-width: 1140px;
`;
const Empty = styled.div`
  ${tw`w-full text-center py-[50px]`}

  h5 {
    ${tw`block text-center pt-[20px]`}
    color: #9ea0a5;
  }

  i {
    color: #9ea0a5;
  }
`;
const Inner = styled.div`
  ${tw`mt-4 mb-8`}
`;

const Subscriptions: React.FC = () => {
  const { loggedIn, user } = useAuth();
  const [clientSecret, setClientSecret] = useState(null);

  useEffect(() => {
    createCustomerSessionMutation.mutate();
  }, []);

  const createCustomerSessionMutation = useMutation({
    mutationFn: () => createCustomerSession(),
    onSuccess: async (data) => {
      console.log("Client secret: ", data);
      setClientSecret(data);
    },
    onError: (error) => {
      console.error("Error creating session", error);
    }
  });

  if (!loggedIn) return null;

  if (!clientSecret) {
    return (
      <Wrap>
        <Empty>
          <Spinner disabled={false} />
        </Empty>
      </Wrap>
    );
  }

  if (!user) {
    return (
      <Wrap>
        <Empty>
          <i className="fas fa-user-times fa-5x"></i>
          <h5>That user was not found.</h5>
        </Empty>
      </Wrap>
    );
  }
  return (
    <div tw="flex flex-col w-full">
      <Inner>
        <script async src="https://js.stripe.com/v3/pricing-table.js"></script>
        <stripe-pricing-table
          pricing-table-id="prctbl_1RHXIODJpLWtANrYp6umTNse"
          publishable-key="pk_live_BMhFPx5BZzxVy5aZS1uipvtE"
          customer-session-client-secret={clientSecret}
        ></stripe-pricing-table>
      </Inner>
    </div>
  );
};

export default Subscriptions;
